import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';

const StyledTableHeader = styled.tr`
  color: #767676;
  font-weight: 400;
  font-size: 16px;
  th {
    padding: ${(props) => (props.hasBreadcrumbs ? '0 0 12px' : '16px 0 12px')};
    position: sticky;
    top: ${(props) => props.stickytop};
    background: #fff;
    z-index: 1;
    &:last-child {
      z-index: 2;
      transform: translateY(-10px);
    }

    @media only screen and (max-width: 556px) {
      background: none;
    }
  }
`;

const HeaderCellWrapper = styled.div`
  cursor: pointer;
  background: #fff;
  padding-bottom: 4px;

  @media only screen and (max-width: 768px) {
    width: auto;
  }

  @media only screen and (max-width: 556px) {
    width: calc(100vw - 60px);
  }
`;

const StyledSortIcon = styled.span`
  color: #767676 !important;
  font-size: 12px;
  line-height: 12px;
  margin-left: 8px;
`;

const StyledHeaderCell = styled.th`
  font-size: 16px;
  font-style: normal;
  font-weight: normal;
  color: #767676 !important;
  border: none !important;
  vertical-align: middle !important;
`;

const StyledNameCell = styled(StyledHeaderCell)`
  @media only screen and (max-width: 556px) {
    div {
      opacity: 0;
    }
  }
`;

const StyledTypeHeader = styled(StyledHeaderCell)`
  width: 80px;
`;

const OptionsHeader = styled(StyledHeaderCell)`
  padding: 0 !important;
`;

const FSObjectListItemHeader = ({
  eventDashOptionsNode,
  onSortChange,
  sorting,
  hasBreadcrumbs,
}) => {
  const headerRef = useRef();
  const [headerTop, setHeaderTop] = useState(0);

  useEffect(() => {
    setHeaderTop(headerRef.current.getBoundingClientRect().top);
  }, []);

  return (
    <thead>
      <StyledTableHeader
        hasBreadcrumbs={hasBreadcrumbs}
        stickytop={`${headerTop}px`}
        ref={headerRef}
      >
        {/* tr */}
        <StyledTypeHeader className="d-none d-sm-table-cell">
          {' '}
          {/* th */}
          <SortableHeaderCell
            currentSorting={sorting}
            onSortToggle={onSortChange}
            sortField="displayType"
            text="Type"
          ></SortableHeaderCell>
        </StyledTypeHeader>
        <StyledNameCell>
          <SortableHeaderCell
            currentSorting={sorting}
            onSortToggle={onSortChange}
            sortField="name"
            text="Name"
          ></SortableHeaderCell>
        </StyledNameCell>
        <StyledHeaderCell className="d-none d-lg-table-cell">
          <SortableHeaderCell
            currentSorting={sorting}
            onSortToggle={onSortChange}
            sortField="startOn"
            text="Start Date"
          ></SortableHeaderCell>
        </StyledHeaderCell>
        <StyledHeaderCell className="d-none d-lg-table-cell">
          <SortableHeaderCell
            currentSorting={sorting}
            onSortToggle={onSortChange}
            sortField="modifiedOn"
            text="Modified"
          ></SortableHeaderCell>
        </StyledHeaderCell>
        <OptionsHeader>{eventDashOptionsNode}</OptionsHeader>
      </StyledTableHeader>
    </thead>
  );
};

FSObjectListItemHeader.propTypes = {
  sorting: PropTypes.object.isRequired,
  onSortChange: PropTypes.func.isRequired,
  eventDashOptionsNode: PropTypes.element,
  hasBreadcrumbs: PropTypes.bool,
};

const SortToggle = ({ sortDirection, onSortToggle }) => {
  const icon = sortDirection === 'desc' ? faAngleDown : faAngleUp;
  return (
    <StyledSortIcon>
      <FontAwesomeIcon icon={icon} onClick={onSortToggle} />
    </StyledSortIcon>
  );
};

SortToggle.propTypes = {
  sortDirection: PropTypes.string.isRequired,
  onSortToggle: PropTypes.func.isRequired,
};

const SortableHeaderCell = ({
  currentSorting,
  onSortToggle,
  text,
  sortField,
}) => {
  const { sortDirection, sortBy } = currentSorting;

  const clickHandler = onSortToggle.bind(null, {
    sortDirection: sortDirection === 'desc' ? 'asc' : 'desc',
    sortBy: sortField,
  });

  return (
    <HeaderCellWrapper onClick={clickHandler}>
      {text}
      <SortToggle
        sortDirection={sortBy === sortField ? sortDirection : 'desc'}
        onSortToggle={clickHandler}
      />
    </HeaderCellWrapper>
  );
};

SortableHeaderCell.propTypes = {
  currentSorting: PropTypes.object.isRequired,
  sortField: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onSortToggle: PropTypes.func.isRequired,
};

export default FSObjectListItemHeader;
